//import firebase from 'firebase'
import firebase from 'firebase/app'
import 'firebase/database'

let firebaseConfig = {
	apiKey: "AIzaSyC8m7xdpoBmRNugOtvmZPzzJHVIqv4Rhyg",
	authDomain: "kira-wpaix.firebaseapp.com",
	databaseURL: "https://kira-wpaix.firebaseio.com",
	storageBucket: "kira-wpaix.appspot.com",
}

var firebaseApp = firebase.initializeApp(firebaseConfig)
var fdb = firebaseApp.database()

export default fdb



// WEBPACK FOOTER //
// ./src/firebase_config.js